import { fetchProductsEtaDates } from '@app/services/productsRepository';
import { useQuery } from '@tanstack/react-query';

export const ETA_DATES_QUERY_KEY = 'etaDatesByDeliveryWindows';

interface Props {
  deliveryWindowIds: string[];
  search: string;
  buyerId: string | undefined;
  isEnabled?: boolean;
}

export const useEtaDates = ({ deliveryWindowIds, search, buyerId, isEnabled }: Props) => {
  return useQuery({
    enabled: isEnabled,
    queryFn: async () => fetchProductsEtaDates({ deliveryWindows: deliveryWindowIds, search: search ?? '' }, buyerId),
    queryKey: [ETA_DATES_QUERY_KEY, buyerId, deliveryWindowIds, search],
    refetchOnMount: false,
  });
};
